import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { FilterSelector, LoadingIcon } from "../index";
import { BaseUrl, Coockies_name } from "../../constants";
import { get_villes } from "../../Utils/villes/get_villes";
import { useCookies } from "react-cookie";
import { get_Activity } from "../../Utils/Activities/Activities";
import { ImgInput } from "../../Utils/ImgInput";
import { DefaultPartner } from "../../constants";
import FormData from "form-data";
import { FaTrash } from "react-icons/fa";
import MapPicker from "../Utils/MapPicker";

const STEPS = ["Médias", "Entreprise", "Contact", "Contenu", "Réseaux Sociaux", "Localisation"];

const OPTIONAL_FIELDS = [
  "facebook_url", "instagram_url", "tiktok_url", "website_url",
  "numero_telephone_fix", "note",
];

const STEP_REQUIRED_FIELDS = [
  ["logo", "cover"],
  ["nome_entreprise", "identificateur_entreprise", "representant_entreprise", "role_dans_entriprise", "adrress", "ville", "activity_entrprise", "_status"],
  ["email", "password", "numero_telephone"],
  ["offer", "description"],
  [],
  [],
];

// ─── Shared primitives ────────────────────────────────────────────────────────

const inputCls = (error) =>
  `w-full bg-gray-100 text-gray-800 border rounded-lg py-2.5 px-3 text-sm focus:outline-none focus:bg-white transition ${
    error ? "border-red-400 focus:border-red-400" : "border-gray-200 focus:border-gray-400"
  }`;

const Field = ({ label, required, error, children }) => (
  <div className="flex flex-col gap-1">
    <label className="text-xs font-bold uppercase tracking-wide text-gray-600">
      {label}{required && <span className="text-red-500 ml-1">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-0.5">{error}</p>}
  </div>
);

const TextAreaField = ({ label, required, value, onChange, error, maxLength = 500 }) => (
  <Field label={label} required={required} error={error}>
    <textarea
      className={`${inputCls(error)} min-h-[90px] resize-y`}
      value={value}
      onChange={onChange}
      maxLength={maxLength}
    />
    <span className="text-xs text-gray-400 text-right self-end">
      {(value || "").length}/{maxLength}
    </span>
  </Field>
);

// ─── Step 0 : Médias ──────────────────────────────────────────────────────────

const StepMedia = ({ data, setdata, errors }) => (
  <div className="flex flex-col gap-6">
    <p className="text-sm text-gray-500">
      Ajoutez le logo et la couverture du partenaire.
    </p>
    <div className="flex flex-row gap-8 flex-wrap justify-center">

      {/* LOGO */}
      <div className="flex flex-col items-center gap-2">
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600">
          Logo <span className="text-red-500">*</span>
        </span>
        {data.logo ? (
          <div className="relative">
            <img
              src={URL.createObjectURL(data.logo)}
              alt="Logo"
              className="w-28 h-28 object-cover rounded-xl border-2 border-gray-200 shadow"
            />
            <button
              type="button"
              onClick={() => setdata({ ...data, logo: null, logo_selected: false })}
              className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center shadow-md transition"
            >
              <FaTrash size={11} />
            </button>
          </div>
        ) : (
          <label className={`w-28 h-28 rounded-xl border-2 border-dashed cursor-pointer flex flex-col items-center justify-center gap-1 transition
            ${errors.logo ? "border-red-400 bg-red-50" : "border-gray-300 bg-gray-50 hover:border-red-400 hover:bg-red-50"}`}
          >
            <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-[11px] text-gray-400 font-medium">Ratio 1:1</span>
            <ImgInput aspectRatio={1} call={(file) => setdata({ ...data, logo: file, logo_selected: true })} />
          </label>
        )}
        {errors.logo && <p className="text-red-500 text-xs">{errors.logo}</p>}
      </div>

      {/* COVER */}
      <div className="flex flex-col items-center gap-2 flex-1 min-w-[220px]">
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600">
          Cover <span className="text-red-500">*</span>
        </span>
        {data.cover ? (
          <div className="relative w-full">
            <img
              src={URL.createObjectURL(data.cover)}
              alt="Cover"
              className="w-full h-24 object-cover rounded-xl border-2 border-gray-200 shadow"
            />
            <button
              type="button"
              onClick={() => setdata({ ...data, cover: null, cover_selected: false })}
              className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center shadow-md transition"
            >
              <FaTrash size={11} />
            </button>
          </div>
        ) : (
          <label className={`w-full h-24 rounded-xl border-2 border-dashed cursor-pointer flex flex-col items-center justify-center gap-1 transition
            ${errors.cover ? "border-red-400 bg-red-50" : "border-gray-300 bg-gray-50 hover:border-red-400 hover:bg-red-50"}`}
          >
            <svg className="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-[11px] text-gray-400 font-medium">1200 × 500 px</span>
            <ImgInput width={1200} height={500} call={(file) => setdata({ ...data, cover: file, cover_selected: true })} />
          </label>
        )}
        {errors.cover && <p className="text-red-500 text-xs">{errors.cover}</p>}
      </div>

    </div>
  </div>
);

// ─── Step 1 : Entreprise ──────────────────────────────────────────────────────

const StepEntreprise = ({ data, setdata, errors, villes, Activities }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="md:col-span-2">
      <Field label="Raison sociale" required error={errors.nome_entreprise}>
        <input
          className={inputCls(errors.nome_entreprise)}
          type="text"
          value={data.nome_entreprise}
          onChange={(e) => setdata({ ...data, nome_entreprise: e.target.value })}
          placeholder="Nom de l'entreprise"
        />
      </Field>
    </div>

    <Field label="ICE" required error={errors.identificateur_entreprise}>
      <input
        className={inputCls(errors.identificateur_entreprise)}
        type="text"
        value={data.identificateur_entreprise}
        onChange={(e) => setdata({ ...data, identificateur_entreprise: e.target.value })}
      />
    </Field>

    <Field label="Représentant" required error={errors.representant_entreprise}>
      <input
        className={inputCls(errors.representant_entreprise)}
        type="text"
        value={data.representant_entreprise}
        onChange={(e) => setdata({ ...data, representant_entreprise: e.target.value })}
      />
    </Field>

    <Field label="Fonction" required error={errors.role_dans_entriprise}>
      <input
        className={inputCls(errors.role_dans_entriprise)}
        type="text"
        value={data.role_dans_entriprise}
        onChange={(e) => setdata({ ...data, role_dans_entriprise: e.target.value })}
      />
    </Field>

    <Field label="Adresse" required error={errors.adrress}>
      <input
        className={inputCls(errors.adrress)}
        type="text"
        value={data.adrress}
        onChange={(e) => setdata({ ...data, adrress: e.target.value })}
      />
    </Field>

    <div>
      <FilterSelector
        title="Ville"
        Filter={data.ville}
        setFilter={(value) => setdata({ ...data, ville: value })}
        options={villes}
        styles="!max-w-full !w-full"
        required
      />
      {errors.ville && <p className="text-red-500 text-xs mt-1">{errors.ville}</p>}
    </div>

    <div>
      <FilterSelector
        title="Secteur d'activité"
        Filter={data.activity_entrprise}
        setFilter={(value) => setdata({ ...data, activity_entrprise: value })}
        options={Activities}
        styles="!max-w-full !w-full"
        required
      />
      {errors.activity_entrprise && <p className="text-red-500 text-xs mt-1">{errors.activity_entrprise}</p>}
    </div>

    <div className="md:col-span-2">
      <FilterSelector
        title="Statut"
        Filter={data._status}
        setFilter={(value) => setdata({ ...data, _status: value })}
        options={[
          { value: "Approved", name: "Approved" },
          { value: "Rejected", name: "Rejected" },
          { value: "Pending", name: "Pending" },
        ]}
        styles="!max-w-full !w-full"
        required
      />
    </div>
  </div>
);

// ─── Step 2 : Contact ─────────────────────────────────────────────────────────

const StepContact = ({ data, setdata, errors }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="md:col-span-2">
      <Field label="Email" required error={errors.email}>
        <input
          className={inputCls(errors.email)}
          type="email"
          value={data.email}
          onChange={(e) => setdata({ ...data, email: e.target.value })}
          placeholder="partenaire@email.com"
        />
      </Field>
    </div>

    <div className="md:col-span-2">
      <Field label="Mot de passe" required error={errors.password}>
        <input
          className={inputCls(errors.password)}
          type="password"
          value={data.password ?? ""}
          onChange={(e) => setdata({ ...data, password: e.target.value })}
          placeholder="••••••••"
        />
      </Field>
    </div>

    <Field label="Numéro Téléphone" required error={errors.numero_telephone}>
      <input
        className={inputCls(errors.numero_telephone)}
        type="text"
        value={data.numero_telephone}
        onChange={(e) => setdata({ ...data, numero_telephone: e.target.value })}
      />
    </Field>

    <Field label="Téléphone Fixe">
      <input
        className={inputCls(false)}
        type="text"
        value={data.numero_telephone_fix}
        onChange={(e) => setdata({ ...data, numero_telephone_fix: e.target.value })}
      />
    </Field>
  </div>
);

// ─── Step 3 : Contenu ─────────────────────────────────────────────────────────

const StepContenu = ({ data, setdata, errors }) => (
  <div className="flex flex-col gap-4">
    <TextAreaField
      label="Offer"
      required
      value={data.offer}
      onChange={(e) => setdata({ ...data, offer: e.target.value })}
      error={errors.offer}
    />
    <TextAreaField
      label="Description"
      required
      value={data.description}
      onChange={(e) => setdata({ ...data, description: e.target.value })}
      error={errors.description}
    />
    <TextAreaField
      label="Note"
      value={data.note}
      onChange={(e) => setdata({ ...data, note: e.target.value })}
    />
  </div>
);

// ─── Step 4 : Réseaux Sociaux ─────────────────────────────────────────────────

const StepReseaux = ({ data, setdata }) => (
  <div className="flex flex-col gap-4">
    <p className="text-sm text-gray-400 bg-gray-50 rounded-lg px-3 py-2 border border-gray-100">
      Tous les champs de cette section sont optionnels.
    </p>
    <Field label="Facebook URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.facebook_url}
        onChange={(e) => setdata({ ...data, facebook_url: e.target.value })}
        placeholder="facebook.com/..."
      />
    </Field>
    <Field label="Instagram URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.instagram_url}
        onChange={(e) => setdata({ ...data, instagram_url: e.target.value })}
        placeholder="instagram.com/..."
      />
    </Field>
    <Field label="TikTok URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.tiktok_url}
        onChange={(e) => setdata({ ...data, tiktok_url: e.target.value })}
        placeholder="tiktok.com/..."
      />
    </Field>
    <Field label="Website URL">
      <input
        className={inputCls(false)}
        type="text"
        value={data.website_url}
        onChange={(e) => setdata({ ...data, website_url: e.target.value })}
        placeholder="website.com/..."
      />
    </Field>
  </div>
);

// ─── Step 5 : Localisation ────────────────────────────────────────────────────

const StepLocalisation = ({ data, setdata }) => (
  <div className="flex flex-col gap-3">
    <p className="text-sm text-gray-500">
      Définissez la position géographique du partenaire sur la carte. (Optionnel)
    </p>
    <MapPicker
      lat={data.lat}
      lng={data.longitude}
      onChange={({ lat, lng }) => setdata({ ...data, lat, longitude: lng })}
    />
  </div>
);

// ─── Main component ───────────────────────────────────────────────────────────

const NewPartner = ({ open, OnClick, setRefresh }) => {
  const [cookies] = useCookies([Coockies_name]);
  const [data, setdata] = useState(DefaultPartner);
  const [loading, setloading] = useState(false);
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [villes, setvilles] = useState([]);
  const [Activities, setActivities] = useState([]);

  const hadlerClose = () => { OnClick(); };

  useEffect(() => {
    if (!loading) hadlerClose();
  }, [loading]);

  useEffect(() => {
    setdata(DefaultPartner);
    setStep(0);
    setErrors({});
  }, [open]);

  useEffect(() => {
    get_villes(setvilles);
    get_Activity(setActivities);
  }, []);

  const validateStep = (stepIndex) => {
    const fields = STEP_REQUIRED_FIELDS[stepIndex];
    const newErrors = {};
    fields.forEach((field) => {
      if (!OPTIONAL_FIELDS.includes(field) && !data[field]) {
        newErrors[field] = "Ce champ est obligatoire";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStepClick = (i) => {
    setErrors({});
    setStep(i);
  };

  const handleNext = () => {
    if (validateStep(step)) setStep((s) => s + 1);
  };

  const handleBack = () => {
    setErrors({});
    setStep((s) => s - 1);
  };

  const handle_submit = async () => {
    if (!validateStep(step)) return;
    setloading(true);
    const formData = new FormData();
    formData.append("images", data.logo);
    formData.append("images", data.cover);
    formData.append("data", JSON.stringify(data));
    try {
      await fetch(`${BaseUrl}/admin/new_partner`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: { Authorization: `Bearer ${cookies.accesToken}` },
        referrerPolicy: "no-referrer",
        body: formData,
      });
      setRefresh((val) => val + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setloading(false);
      setdata({});
    }
  };

  return (
    <Dialog open={open} keepMounted fullWidth maxWidth="md" onClose={hadlerClose}>

      {/* ── Header ── */}
      <div className="bg-white px-6 pt-6 pb-4 border-b border-gray-100">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Nouveau Partenaire</h2>
            <p className="text-xs text-gray-400 mt-0.5">
              <span className="text-red-500">*</span> Champs obligatoires
            </p>
          </div>
          <button
            type="button"
            onClick={hadlerClose}
            className="text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition text-lg font-bold"
          >
            ×
          </button>
        </div>

        {/* Stepper */}
        <div className="flex items-center mt-5">
          {STEPS.map((label, i) => (
            <React.Fragment key={i}>
              <button
                type="button"
                onClick={() => handleStepClick(i)}
                className="flex flex-col items-center group"
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all group-hover:opacity-80
                  ${i < step ? "bg-green-500 text-white" : i === step ? "bg-red-500 text-white" : "bg-gray-100 text-gray-400"}`}
                >
                  {i < step ? "✓" : i + 1}
                </div>
                <span className={`text-[10px] mt-1 font-semibold whitespace-nowrap
                  ${i === step ? "text-red-500" : i < step ? "text-green-500" : "text-gray-400"}`}
                >
                  {label}
                </span>
              </button>
              {i < STEPS.length - 1 && (
                <div className={`flex-1 h-[2px] mx-1 mb-4 rounded ${i < step ? "bg-green-400" : "bg-gray-200"}`} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── Content ── */}
      <DialogContent className="!px-6 !py-5">
        <div className="min-h-[300px]">
          {step === 0 && <StepMedia data={data} setdata={setdata} errors={errors} />}
          {step === 1 && <StepEntreprise data={data} setdata={setdata} errors={errors} villes={villes} Activities={Activities} />}
          {step === 2 && <StepContact data={data} setdata={setdata} errors={errors} />}
          {step === 3 && <StepContenu data={data} setdata={setdata} errors={errors} />}
          {step === 4 && <StepReseaux data={data} setdata={setdata} />}
          {step === 5 && <StepLocalisation data={data} setdata={setdata} />}
        </div>

        {/* ── Navigation ── */}
        <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-100">
          <button
            type="button"
            onClick={handleBack}
            disabled={step === 0}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm font-medium disabled:opacity-30 hover:bg-gray-50 transition"
          >
            ← Précédent
          </button>

          {step < STEPS.length - 1 ? (
            <button
              type="button"
              onClick={handleNext}
              className="px-6 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm font-bold transition"
            >
              Suivant →
            </button>
          ) : (
            <button
              type="button"
              onClick={handle_submit}
              disabled={loading}
              className="px-6 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm font-bold transition flex items-center gap-2 disabled:opacity-60"
            >
              {LoadingIcon(loading)}
              Confirmer
            </button>
          )}
        </div>
      </DialogContent>

    </Dialog>
  );
};

export default NewPartner;
